import {TFunction} from 'i18next';

import {IBalanceItemMemberUI} from '../models/interfaces';

import {formatMembersSummary} from './formatMembersSummary';

export const getBalanceItem = (
  amount: number,
  membersWithBalance: IBalanceItemMemberUI[],
  titleKey: string,
  membersKey: string,
  emptyKey: string,
  t: TFunction,
) => ({
  title: t(titleKey, {amount: amount.toFixed(2)}),
  subtitle: membersWithBalance.length
    ? t(membersKey, {members: formatMembersSummary(membersWithBalance, t)})
    : t(emptyKey),
});
